<template>
  <div class="commonProblem">
    <Header :headerTitle="$t('m.commonProblem.title')"></Header>
    <ol>
      <li>{{$t('m.commonProblem.contextq1')}}</li>
      <li>{{$t('m.commonProblem.contexta1')}}</li>
      <li>{{$t('m.commonProblem.contextq2')}}</li>
      <li>{{$t('m.commonProblem.contexta2')}}</li>
      <li>{{$t('m.commonProblem.contextq3')}}</li>
      <li>{{$t('m.commonProblem.contexta3')}}</li>
      <li>{{$t('m.commonProblem.contextq4')}}</li>
      <li>{{$t('m.commonProblem.contexta4')}}</li>
      <li>{{$t('m.commonProblem.contextq5')}}</li>
      <li>{{$t('m.commonProblem.contexta5')}}</li>
      <!-- <li>{{$t('m.commonProblem.contextq6')}}</li>
      <li>{{$t('m.commonProblem.contexta6')}}</li>
      <li>{{$t('m.commonProblem.contextq7')}}</li>
      <li>{{$t('m.commonProblem.contexta7')}}</li>
      <li>{{$t('m.commonProblem.contextq8')}}</li>
      <li>{{$t('m.commonProblem.contexta8')}}</li> -->
    </ol>
  </div>
</template>
<script>
  export default {
    name: "commonProblem",
    data() {
      return {};
    }
  };
</script>
<style scoped>
  .commonProblem ol {
    margin: 10px 10px 10px 10px;
    padding: 5px;
    list-style: none;
    text-align: left;

  }
  .commonProblem ol li {
    margin-bottom: 5px;
    font-size: 0.96rem;
  }
  .commonProblem ol li:nth-child(even){
      margin-bottom: 10px;
  }
</style>

